__turbopack_context__.v({
  "ctaStyle": "VTQhHa_ctaStyle",
  "ctaTypeStyle": "VTQhHa_ctaTypeStyle",
});
